<div class="chat-message">
    <dsn-avatar
        [src]="avatar"
        [size]="'small'"
        [initials]="initials"
    ></dsn-avatar>
    <div class="chat-message__user">
        <div class="chat-message__user-info">
            <h3 class="user-name {{ isMobileComment && 'mobile' }}" fxFlex>
                {{ userName }}
            </h3>
            <div
                fxLayout="row"
                fxLayoutAlign="end center"
                fxLayoutGap="var(--spacing-4)"
                style="height: 20px"
            >
                @if (date) {
                    <span class="chat-message__date">{{ date }}</span>
                }

                @if (showDelete && postUserId === userId) {
                    <dsn-button-rounded
                        type="secondary"
                        icon="fa-solid fa-trash-can"
                        size="medium"
                        (click)="handleDelete()"
                    ></dsn-button-rounded>
                }
            </div>
        </div>
        <p class="chat-message__message {{ isMobileComment && 'mobile' }}">
            {{ message }}
        </p>
    </div>
</div>
